export default function getCutoffPeriod(dr) { 
  // Make sure dr exists
  if (!dr || !dr.payroll_from || !dr.payroll_to) {
    return ""; 
  }

  const fromDate = new Date(dr.payroll_from);
  const toDate = new Date(dr.payroll_to);

  const monthFrom = fromDate.toLocaleString('en-US', { month: 'short' }).toUpperCase();
  const monthTo = toDate.toLocaleString('en-US', { month: 'short' }).toUpperCase();

  const fromDay = String(fromDate.getDate()).padStart(2, '0');
  const toDay = String(toDate.getDate()).padStart(2, '0');

  const year = String(fromDate.getFullYear()).slice(2);

  return `${monthFrom}${fromDay}-${monthTo}${toDay}-${year}`;
}